import { ChangeDetectorRef, Component, OnChanges, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { AppConfig } from "src/app/app.config";
import { HolidayListService } from "src/app/shared/service/holidaylist.service";
import { UserService } from "src/app/shared/service/user.service";
import { isNullOrUndefined } from "util";
import { Router, ActivatedRoute } from "@angular/router";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatAutocomplete,
  MatAutocompleteTrigger,
  MatDatepickerInputEvent,
  MatDialog,
  MatPaginator,
  MatSelect,
  MatSort,
  MatTableDataSource,
  Sort,
} from "@angular/material";
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from "@angular/material-moment-adapter";
import {
    FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from "src/app/shared/components/confirm-dialog/confirm-dialog.component";
import { DatePipe } from "@angular/common";

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-hr-holidays-details",
  templateUrl: "./hr-holidays-details.component.html",
  styleUrls: ["./hr-holidays-details.component.css"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class HRHolidaysDetailsComponent implements OnInit {
  holidaysListTableDataSource: MatTableDataSource<any>;
  error: string;
  MangemployeeList: any;
  vendorList = [];
  currentMonth = "";
  currentFY = "";
  isFreeze = true;
  saved = false;
  submited = false;
  IsApproved = false;
  LoginEmpCode = "";

  minDate: any;
  minDateApporver: any;
  holidaysListTableForm: FormGroup;
  loginName = "";
  lstData: any;
  currentDate = new Date();
  @ViewChild("holidaysListTablePaginationAll", { static: true })
  holidaysListTablePaginationAll: MatPaginator;
  @ViewChild("holidaysListTableDatasortAll", { static: true })
  holidaysListTableDatasortAll: MatSort;
  holidaysListTableHeaders = this.submitHolidayListFormBuilder.array([])
  holidaysListHeaders: string[] = [
    "HolidayListId",
    "Date",
    "Day",
    "Occasion",
    "ApplicableTo",
    "HolidayType",
    "remove",
  ];
  applicableToList = [];
  applicableTo: any[] = [];
  DaysList = [];
  holidayTypeList = [
    {
      Name: "Regular",
    },
    {
      Name: "Special",
    },
  ];
  originalData = [];
  isSave: boolean = false;
  holidaysList: any;
  holidayListingId = "";
  selectedApplicableTo: string[][] = [];
  holidaysLocationList: any=[];
  @ViewChild(MatSelect, {static:false}) select: MatSelect;
  constructor(
    private _service: HolidayListService,
    private config: AppConfig,
    public router: Router,
    private toastr: ToastrService,
    public _userService: UserService,
    private submitHolidayListFormBuilder: FormBuilder,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
    this.holidaysListTableForm = this.submitHolidayListFormBuilder.group({
      holidaysListTableHeaders: this.holidaysListTableHeaders,
    });
    this.holidaysListTableDataSource = new MatTableDataSource();
    this.LoginEmpCode = this._userService.getEmpCode().toString();
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.holidayListingId = params["id"];
    });
    this.getAllHolidays();
    var today = new Date();
    this.DaysList = [
      {
        Name: "Sunday",
      },
      {
        Name: "Monday",
      },
      {
        Name: "Tuesday",
      },
      {
        Name: "Wednesday",
      },
      {
        Name: "Thursday",
      },
      {
        Name: "Friday",
      },
      {
        Name: "Saturday",
      },
    ];
    this.getLocationsFun()
    this.minDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    this.minDateApporver = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() + 1
    );
    this.loginName = this._userService.getEmail();
  }

  ngDoCheck() {
    let newData = this.holidaysListTableDataSource.data || [];
    newData =
      newData &&
      newData.map(({ Date, Day, Occasion, ApplicableTo, HolidayType }) => ({
        Date,
        Day,
        Occasion,
        ApplicableTo,
        HolidayType,
      }));

    if (this.isDataChanged(this.originalData, newData)) {
      this.isSave = true;
    } else {
      this.isSave = false;
    }
  }

  getAllHolidays() {
    this._service.GetHolidayDetails().subscribe(
      (data: any[]) => {
        if (data != null && data.length > 0) {
          var details = data.filter(holidays => holidays.Id == this.holidayListingId);
          if (details != null) {
            this.holidaysList = details[0]
          }
        }
      });
  }

  // Deep comparison of objects
  isDataChanged(oldData: any, newData: any): boolean {
    return JSON.stringify(oldData) === JSON.stringify(newData);
  }

  createHolidayDetails() {
    var row = {
      HolidayListId: this.holidayListingId,
      Date: "",
      Day: "",
      Occasion: "",
      ApplicableTo: [],
      HolidayType: "",
      remove: "",
    };
    return row;
  }

  filterEmployee(values, NamePerRecords) {
    return values.filter((value) =>
      !!value.NamePerRecords && value.NamePerRecords != ""
        ? value.NamePerRecords.toLowerCase().includes(
            NamePerRecords.toLowerCase()
          )
        : ""
    );
  }

  removeSubmittedRecord(index: number, row: any) {
    const msg = "Are you sure you want to delete this record?";
    const dialogData = new ConfirmDialogModel(" ", msg, "Submit");
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "800px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.holidaysListTableHeaders.value.splice(index, 1);
          this.applicableTo.splice(index,1)
          var arr = this.holidaysListTableHeaders.value;
          this.holidaysListTableHeaders.clear();
          for (var i = 0; i < arr.length; i++) {
            if (!Array.isArray(arr[i].ApplicableTo)) {
              this.applicableTo[i] = arr[i].ApplicableTo ? arr[i].ApplicableTo.split(',').map(item => item.trim()) : [];
            }
            this.createHolidayListFormGroup(arr[i]);
          }

          this.holidaysListTableDataSource.data = this.holidaysListTableHeaders.value;
          this.deleteHolidayListDetails(row);
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  onSelectBlur(select: MatSelect) {
    select.close();
  }

  onSelectClick(select) {
    select.open();
  }

  onMouseLeave(select) {
    select.close()
  }

  deleteHolidayListDetails(row) {
    if (row.Id > 0) {
      this._service.DeleteHolidayListDetails({ Id: row.Id }).subscribe(
        (data: any[]) => {
          this.toastr.success("Deleted Successfully");
          this.getAllHolidaysList();
        },
        (error) => (this.error = error)
      );
    }
  }

  sortData(sort: Sort): void {
    this.lstData = this.holidaysListTableDataSource.data;
    let data = this.lstData.slice();
    if (!sort.active || sort.direction == "") {
      this.holidaysListTableDataSource = new MatTableDataSource(data);
      return;
    }

    this.holidaysListTableDataSource = new MatTableDataSource(
      data.sort((a, b) => {
        let isdesc = sort.direction == "desc";
        switch (sort.active) {
          case "Date":
            return compare(a.Date, b.Date, isdesc);
          default:
            return 0;
        }
      })
    );
  }

  addHolidayListRow() {
    this.createHolidayListFormGroup();
    var arr = this.holidaysListTableHeaders.value;
    //console.log(JSON.parse(JSON.stringify(this.holidaysListTableHeaders.value)))
    this.holidaysListTableHeaders.clear();
    for (var i = 0; i < arr.length; i++) {
      if (!Array.isArray(arr[i].ApplicableTo)) {
        this.applicableTo[i] = arr[i].ApplicableTo ? arr[i].ApplicableTo.split(',').map(item => item.trim()) : [];
      }
      this.createHolidayListFormGroup(arr[i]);
    }
    this.holidaysListTableDataSource.data = this.holidaysListTableHeaders.value;
    this.applicableToList[this.holidaysListTableDataSource.data.length - 1] = this.holidaysLocationList;
    this.applicableTo[this.holidaysListTableDataSource.data.length - 1] = [];
    this.holidaysListTableDataSource.filter = "";
  }

  daySelectdFun(event, row) {
    // row.Day = event.option.Name;
  }

  isDisabled(date,rowIndex, type) {
    if (date != null && date != '') {
      var fromDate = new Date(date)
      fromDate.setHours(0, 0, 0, 0);
      this.currentDate.setHours(0, 0, 0, 0)
      if (type == null && !(fromDate.getTime() >= this.currentDate.getTime())) {
        const row = this.holidaysListTableForm.get('holidaysListTableHeaders') as FormArray;
        return fromDate.getTime() >= this.currentDate.getTime() ? false : row.controls.forEach((control, index) => {
          if (index === rowIndex) {
            control.disable();
          }
        });
      }
      else if (type != null) {
        return fromDate.getTime() >= this.currentDate.getTime() ? false : true;
      }
      else {
        if (type == null) {
          const row = this.holidaysListTableForm.get('holidaysListTableHeaders') as FormArray;
          return fromDate.getTime() >= this.currentDate.getTime() ? false : row.controls.forEach((control, index) => {
            if (index === rowIndex) {
              control.enable();
            }
          })
        }
        else {
          return fromDate >= this.currentDate ? false : true;
        }
      }
    }
    else {
      const row = this.holidaysListTableForm.get('holidaysListTableHeaders') as FormArray;
      return fromDate >= this.currentDate ? false : row.controls.forEach(control => {
        control.enable();
      });
    }
  }

  DDSelectd(event, row, rowIndex) {
    const selectedValue = event.value;
    row.ApplicableTo = selectedValue.join(', ');
    this.applicableTo[rowIndex] = selectedValue;
  }

  changed(row) {
    row.IsUpdated = true;
  }

  mangerSubmited() {
    this.submited = true;
    var datePipe = new DatePipe("en-US");
    this.holidaysListTableForm.markAllAsTouched();
    if (this.holidaysListTableForm.invalid) {
      this.toastr.warning("Please fill the required fields")
      return
    }
    if (this.holidaysListTableDataSource != null && this.holidaysListTableDataSource.data.length > 0) {
      for (var i = 0; i < this.holidaysListTableDataSource.data.length; i++) {
        if (this.holidaysListTableDataSource.data[i] != null) {
          if (Array.isArray(this.applicableTo[i])) {
            this.holidaysListTableDataSource.data[i].ApplicableTo = this.applicableTo[i].join(', ');
          }
          this.holidaysListTableDataSource.data[i].Date = this.holidaysListTableDataSource.data[i].Date != null && this.holidaysListTableDataSource.data[i].Date != '' ? new Date(
            datePipe.transform(this.holidaysListTableDataSource.data[i].Date, this.config.dateFormat())) : this.holidaysListTableDataSource.data[i].Date;
        }
      }
    }
    this.SaveConfirmation();
  }

  mangerSaved() {
    this.saved = true;
    var datePipe = new DatePipe("en-US");
    this.holidaysListTableForm.markAllAsTouched();
    var arr = this.holidaysListTableDataSource.data;
    this.holidaysListTableHeaders.clear();
    for (var i = 0; i < arr.length; i++) {
      this.createHolidayListFormGroup(arr[i]);
    }
    if (this.holidaysListTableForm.invalid) {
      this.toastr.warning("Please fill the  required fields")
      //const hedaers = this.holidaysListTableHeaders;
      //console.log(hedaers)
      //hedaers.controls.forEach((control, index) => {
      //  if (control.invalid) {
      //    console.log({ index, control });
      //  }
      //});
      return
    }
    if (this.holidaysListTableDataSource != null && this.holidaysListTableDataSource.data.length > 0) {
      for (var i = 0; i < this.holidaysListTableDataSource.data.length; i++) {
        if (this.holidaysListTableDataSource.data[i] != null) {
          if (Array.isArray(this.applicableTo[i])) {
            this.holidaysListTableDataSource.data[i].ApplicableTo = this.applicableTo[i].join(', ');
          }
          this.holidaysListTableDataSource.data[i].Date = this.holidaysListTableDataSource.data[i].Date != null && this.holidaysListTableDataSource.data[i].Date != '' ? new Date(
            datePipe.transform(this.holidaysListTableDataSource.data[i].Date, this.config.dateFormat())) : this.holidaysListTableDataSource.data[i].Date;
        }
      }
    }
    this.SaveConfirmation();
  }

  saveHolidayListRecord() {
    var result = this.holidaysListTableDataSource.data;
    if (result != null && result.length > 0) {
      this._service.SaveHolidayDetailsList(result).subscribe(
        (data: any[]) => {
          if (this.submited == true) {
            this.toastr.success("Submitted Successfully");
          } else {
            this.toastr.success("Saved Successfully");
          }
          this.getAllHolidaysList();
        },
        (error) => (this.error = error)
      );
    }
  }

  getLocationsFun() {
    this._service.GetWorkShift().subscribe(
      (data: any[]) => {
        this.holidaysLocationList = data;
        this.getAllHolidaysList();
      },
      (error) => (this.error = error)
    );
  }

  getAllHolidaysList() {
    this.holidaysListTableDataSource.data = [];
    this._service.GetHolidayListDetails(this.holidayListingId).subscribe(
      (data: any[]) => {
        this.holidaysListTableHeaders = this.submitHolidayListFormBuilder.array([]);
        this.holidaysListTableForm = this.submitHolidayListFormBuilder.group({
          holidaysListTableHeaders: this.holidaysListTableHeaders,
        });
        if (data != null && data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            this.applicableToList[i] = this.holidaysLocationList;
            if (!Array.isArray(data[i].ApplicableTo)) {
              this.applicableTo[i] = data[i].ApplicableTo ? data[i].ApplicableTo.split(',').map(item => item.trim()) : [];
            }
            this.createHolidayListFormGroup(data[i]);
          }
          this.holidaysListTableDataSource.data = data;
          this.originalData =
            data &&
            data.map(({ Date, Day, Occasion, ApplicableTo, HolidayType }) => ({
              Date,
              Day,
              Occasion,
              ApplicableTo,
              HolidayType,
            }));
          this.holidaysListTableDataSource.paginator =
            this.holidaysListTablePaginationAll;
          this.holidaysListTableDataSource.sort =
            this.holidaysListTableDatasortAll;
        }
      },
      (error) => (this.error = error)
    );
  }

  SaveConfirmation() {
    const msg = "Are you sure you want to Save the record(s)?";
    const dialogData = new ConfirmDialogModel(" ", msg, "Submit");
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "800px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.saveHolidayListRecord();
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  setDate(event: any): any {
    const selectedDate = event.value;
    if (selectedDate) {
      const d = new Date(selectedDate);
      return new Date(
        d.getFullYear(),
        d.getMonth(),
        d.getDate(),
        d.getHours(),
        d.getMinutes() - d.getTimezoneOffset()
      ).toISOString();
    }
    return "";
  }

  FromDateChanged(row, event: MatDatepickerInputEvent<Date>) {
    // row.holidayDate = this.setDate(event);
    const selectedDate = event.value;
    const d = new Date(selectedDate);
    row.Day = this.DaysList[d.getDay()].Name;
  }

  private createHolidayListFormGroup(item = null) {
    var row;
    if (item != null) {
      item.Date = item.Date != null ? new Date(item.Date) : item.Date
    }
    if (item != null) {
      row = this.submitHolidayListFormBuilder.group({
        Id: [item.Id],
        HolidayListId: [item.HolidayListId, Validators.required],
        Date: [item.Date, Validators.required],
        Day: [item.Day, Validators.required],
        Occasion: [item.Occasion, Validators.required],
        ApplicableTo: [Array.isArray(item.ApplicableTo) ? item.ApplicableTo : item.ApplicableTo ? item.ApplicableTo.split(',').map(it => it.trim()) : [], Validators.required],
        HolidayType: [item.HolidayType, Validators.required],
      });
    } else {
      row = this.submitHolidayListFormBuilder.group({
        Id: [""],
        HolidayListId: [this.holidayListingId, Validators.required],
        Date: ["", Validators.required],
        Day: ["", Validators.required],
        Occasion: ["", Validators.required],
        ApplicableTo: ["", Validators.required],
        HolidayType: ["", Validators.required],
      });
    }
    this.holidaysListTableHeaders.push(row);
  }

  BackTab() {
    this.router.navigate(["/holidaylist"]);
  }
}

function compare(a, b, isdesc) {
  if (a === null) {
    return 1;
  }
  if (b === null) {
    return -1;
  }

  if (a === b) return 0;

  if (isdesc) return a < b ? 1 : -1;
  else return a < b ? -1 : 1;
}

